import React from "react";
import { Row, Col } from "react-bootstrap";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { TransferDesign } from "./TransferDesign";
import { ActionMenu } from "./ActionMenu";

import { useIntl } from "react-intl";
import { CallAPI } from "../../../../config/api/ApiConfig";
import { useNavigate } from "react-router-dom";
import { PATH_PAGE } from "../../../../routes/Paths";

export const ReservTable = () => {
    const { messages } = useIntl();
    const navigate = useNavigate();

    const { data: tableData } = CallAPI({
        name: "reviews",
        url: "/mentor/v1/bookings",
        refetchOnWindowFocus: false,
        enabled: true,
        select: (res) => res?.data?.data,
    });

    const tableHeader = [
        messages["reservation_id"],
        messages["reservation_date"],
        messages["booking_statue"],
        messages["attendance_status"],
        messages["actions"],
    ];

    const handleNavigation = (param) => {
        const queryParams = { id: param };
        const searchParams = new URLSearchParams(queryParams).toString();
        navigate(`${PATH_PAGE.reservDetails}?${searchParams}`);
    };

    return (
        <div className="mt-4">
            <div className="head_box mb-3">
                <h2 className="heading_dash mb-1">
                    {messages["other_reservations"]}
                </h2>
                <p className="heading_dis">{messages["see_also"]}</p>
            </div>
            <Row>
                <Col xs={12}>
                    <TableContainer className="parent-table">
                        <Table className="table">
                            <TableHead className="table_header">
                                <TableRow className="table_header-row">
                                    {tableHeader?.map((d, i) => (
                                        <TableCell
                                            key={d}
                                            align={
                                                i === 2 || i === 4
                                                    ? "center"
                                                    : ""
                                            }
                                            className="table_header-row_heading"
                                        >
                                            {d}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.map((data) => (
                                    <TableRow
                                        key={data?.id}
                                        className="table_body-row"
                                    >
                                        <TableCell className="table_body-row_data tertiary">
                                            {data?.id}
                                        </TableCell>
                                        <TableCell className="table_body-row_data">
                                            {data?.start_session}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className="table_body-row_data"
                                        >
                                            {data?.status === "complete" ? (
                                                <TransferDesign
                                                    className="green"
                                                    text={messages["completed"]}
                                                />
                                            ) : data?.status === "canceled" ? (
                                                <TransferDesign
                                                    className="red"
                                                    text={
                                                        messages[data?.status]
                                                    }
                                                />
                                            ) : data?.status === "scheduled" ? (
                                                <TransferDesign
                                                    className="orange"
                                                    text={
                                                        messages[data?.status]
                                                    }
                                                />
                                            ) : null}
                                        </TableCell>
                                        <TableCell
                                            className={`table_body-row_data ${data?.attend_status === 1 ? "tertiary" : ""}`}
                                        >
                                            {data?.attend_status === 1
                                                ? messages["attended"]
                                                : "-"}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className="table_body-row_data"
                                        >
                                            <ActionMenu
                                                onClick={() =>
                                                    handleNavigation(data?.id)
                                                }
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Col>
            </Row>
        </div>
    );
};
